import React from "react";
import { Footer } from "../design-system";

/* The design system's Footer renders plain anchors, so internal paths are routed
   by the document-level interceptor in index.tsx rather than per link. */
const columns = [
  {
    title: "Project",
    links: [
      { label: "GitHub", href: "https://github.com/vanillabp" },
      { label: "SPI for Java", href: "https://github.com/vanillabp/spi-for-java" },
      { label: "Business Cockpit", href: "https://github.com/vanillabp/business-cockpit" },
    ],
  },
  {
    title: "Learn",
    links: [
      { label: "Get started", href: "/start" },
      { label: "Features", href: "/features-list" },
      { label: "Adapters", href: "/features" },
      { label: "Blueprints", href: "/blueprints" },
    ],
  },
  {
    title: "Contact",
    links: [{ label: "Get in touch", href: "/about#contact" }],
  },
];

const note =
  "Apache License 2.0 · Camunda is a trademark of Camunda Services GmbH, used nominatively. Phactum logo used with permission.";

export const SiteFooter = () => <Footer columns={columns} note={note} logoBase="/img/logo" />;
